import { apiSlice as api } from '../../../../apiSlice';
export const addTagTypes = ['Accounts'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      accountsGetCollectionAsyncByqueryOptions: build.query<
        AccountsGetCollectionAsyncByqueryOptionsApiResponse,
        AccountsGetCollectionAsyncByqueryOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/Accounts`,
          params: {
            orderby: queryArg.orderby,
            orderbydesc: queryArg.orderbydesc,
            top: queryArg.top,
            skip: queryArg.skip,
          },
        }),
        providesTags: ['Accounts'],
      }),
      accountsPostAsyncBynewAccount: build.mutation<
        AccountsPostAsyncBynewAccountApiResponse,
        AccountsPostAsyncBynewAccountApiArg
      >({
        query: (queryArg) => ({
          url: `/Accounts`,
          method: 'POST',
          body: queryArg.writeAccountDto,
        }),
        invalidatesTags: ['Accounts'],
      }),
      accountsGetAsyncByid: build.query<
        AccountsGetAsyncByidApiResponse,
        AccountsGetAsyncByidApiArg
      >({
        query: (queryArg) => ({ url: `/Accounts/${queryArg.id}` }),
        providesTags: ['Accounts'],
      }),
      accountsPatchByiddto: build.mutation<
        AccountsPatchByiddtoApiResponse,
        AccountsPatchByiddtoApiArg
      >({
        query: (queryArg) => ({
          url: `/Accounts/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.writeAccountDto,
        }),
        invalidatesTags: ['Accounts'],
      }),
      accountsPutUserAsyncByiddto: build.mutation<
        AccountsPutUserAsyncByiddtoApiResponse,
        AccountsPutUserAsyncByiddtoApiArg
      >({
        query: (queryArg) => ({
          url: `/Accounts/${queryArg.id}/Users`,
          method: 'PUT',
          body: queryArg.writeUserRoleDto,
        }),
        invalidatesTags: ['Accounts'],
      }),
      accountsDeleteUserAsyncByidemailrole: build.mutation<
        AccountsDeleteUserAsyncByidemailroleApiResponse,
        AccountsDeleteUserAsyncByidemailroleApiArg
      >({
        query: (queryArg) => ({
          url: `/Accounts/${queryArg.id}/Users/${queryArg.email}/${queryArg.role}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Accounts'],
      }),
      accountsPutServiceAsyncByaccountIdserviceId: build.mutation<
        AccountsPutServiceAsyncByaccountIdserviceIdApiResponse,
        AccountsPutServiceAsyncByaccountIdserviceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Accounts/${queryArg.accountId}/Service/${queryArg.serviceId}`,
          method: 'PUT',
        }),
        invalidatesTags: ['Accounts'],
      }),
      accountsDeleteServiceAsyncByaccountIdserviceId: build.mutation<
        AccountsDeleteServiceAsyncByaccountIdserviceIdApiResponse,
        AccountsDeleteServiceAsyncByaccountIdserviceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Accounts/${queryArg.accountId}/Service/${queryArg.serviceId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Accounts'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcOpenApi };
export type AccountsGetCollectionAsyncByqueryOptionsApiResponse =
  /** status 200 Account entities response */ ReadAccountDto[];
export type AccountsGetCollectionAsyncByqueryOptionsApiArg = {
  /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>AccountId</strong> (default), <strong>Name</strong>.</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderby?: string;
  /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>AccountId</strong> (default), <strong>Name</strong>.</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderbydesc?: string;
  /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
  top?: number;
  /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
  skip?: number;
};
export type AccountsPostAsyncBynewAccountApiResponse =
  /** status 201 Created */ object;
export type AccountsPostAsyncBynewAccountApiArg = {
  /** The entity to create */
  writeAccountDto: WriteAccountDto;
};
export type AccountsGetAsyncByidApiResponse =
  /** status 200 Account entities response */ ReadAccountDto;
export type AccountsGetAsyncByidApiArg = {
  /** Id of entity to retrieve */
  id: number;
};
export type AccountsPatchByiddtoApiResponse =
  /** status 204 No content */ object;
export type AccountsPatchByiddtoApiArg = {
  /** The id of the account */
  id: number;
  /** New account value */
  writeAccountDto: WriteAccountDto;
};
export type AccountsPutUserAsyncByiddtoApiResponse =
  /** status 204 No content */ object;
export type AccountsPutUserAsyncByiddtoApiArg = {
  /** Account Id */
  id: number;
  /** The user and role to add */
  writeUserRoleDto: WriteUserRoleDto;
};
export type AccountsDeleteUserAsyncByidemailroleApiResponse =
  /** status 204 No content */ object;
export type AccountsDeleteUserAsyncByidemailroleApiArg = {
  /** Account Id */
  id: number;
  /** The email of the user to remove */
  email: string;
  /** The role to remove the user from */
  role: 'Administrator' | 'User' | 'ReadOnly';
};
export type AccountsPutServiceAsyncByaccountIdserviceIdApiResponse =
  /** status 204 Created */ object;
export type AccountsPutServiceAsyncByaccountIdserviceIdApiArg = {
  /** The account id */
  accountId: number;
  /** The service id */
  serviceId: number;
};
export type AccountsDeleteServiceAsyncByaccountIdserviceIdApiResponse =
  /** status 204 No content */ object;
export type AccountsDeleteServiceAsyncByaccountIdserviceIdApiArg = {
  /** The account id */
  accountId: number;
  /** The service id */
  serviceId: number;
};
export type UserNoRefsDto = {
  UserId: number;
  Email: string;
  Created: string;
  Active: boolean;
  TimeZone?: string;
};
export type ReadUserRolesDto = {
  User?: UserNoRefsDto;
  Roles?: string[];
};
export type ReadServiceDto = {
  Id: number;
  Name?: string;
};
export type ReadAccountDto = {
  AccountId: number;
  Name: string;
  Address: string;
  BillingAddress?: string;
  UserRoles?: ReadUserRolesDto[];
  Services?: ReadServiceDto[];
};
export type ErrorResult = {
  Code: string;
  Message: string;
};
export type BadRequestError = {
  Code: string;
  Message: string;
};
export type PropertyValueError = {
  Property: string;
  Code: string;
  Message: string;
};
export type ArrayProperty = {
  Property?: ArrayProperty;
  Name: string;
  Index?: number;
};
export type ArrayPropertyValueError = {
  Property: ArrayProperty;
  Code: string;
  Message: string;
};
export type ErrorDetailsResult2 = ErrorResult & {
  BadRequestErrors?: BadRequestError[];
  PropertyValueErrors?: PropertyValueError[];
  ArrayPropertyValueErrors?: ArrayPropertyValueError[];
};
export type ErrorDetailsResult = ErrorDetailsResult2;
export type ErrorResult2 = ErrorResult;
export type ErrorResult3 = ErrorResult;
export type ErrorResult4 = ErrorResult;
export type WriteAccountDto = {
  Name: string;
  Address: string;
  BillingAddress?: string;
};
export type WriteUserRoleDto = {
  Email: string;
  Role: 'Administrator' | 'User' | 'ReadOnly';
};
export const {
  useAccountsGetCollectionAsyncByqueryOptionsQuery,
  useLazyAccountsGetCollectionAsyncByqueryOptionsQuery,
  useAccountsPostAsyncBynewAccountMutation,
  useAccountsGetAsyncByidQuery,
  useLazyAccountsGetAsyncByidQuery,
  useAccountsPatchByiddtoMutation,
  useAccountsPutUserAsyncByiddtoMutation,
  useAccountsDeleteUserAsyncByidemailroleMutation,
  useAccountsPutServiceAsyncByaccountIdserviceIdMutation,
  useAccountsDeleteServiceAsyncByaccountIdserviceIdMutation,
} = injectedRtkApi;
